import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { images, strings } from 'config';

class ViewDetail extends Component {
  goToPage = pageLink => {
    this.props.history.push(pageLink);
    window.location.reload();
  };

  render() {
    const { pageLink, title, type } = this.props;

    if (type === 'mun') {
      return (
        <Content lang={strings.getLanguage()}>
          <a href={pageLink} target="_blank">
            {title}
            <img src={images.icons.forward} alt="Forward" />
          </a>
        </Content>
      );
    }

    return (
      <Content className="view-detail">
        <span onClick={() => this.goToPage(pageLink)}>
          {title}
          <img src={images.icons.forward} alt="Forward" />
        </span>
      </Content>
    );
  }
}

ViewDetail.propTypes = {
  pageLink: PropTypes.string.isRequired
};

export default withRouter(ViewDetail);

const Content = styled.div`
  > a,
  span {
    color: ${props => props.theme.teals.tilicho};
    font-size: ${props => (props.lang === 'en' ? '12px' : '14px')};
    cursor: pointer;
    > img {
      display: inline-block;
      margin-left: 6px;
      vertical-align: middle;
      transition: all 0.2s ease-in;
    }

    &:hover {
      img {
        transform: translateX(2px);
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/viewDetail/viewDetail.js